import { useEffect, useMemo, useState } from "react";
import { useSelector } from "react-redux";
import { selectEntitiesByFilters } from '../../../../../../shared/store/views/entityView';
import { studyGroupsBySchoolIdFilters } from "../../../../../../shared/utils/entitiesFiltersUtils";
import StudyGroupListSection from "./StudyGroupListSection/StudyGroupListSection";
import classes from "./UserStudyGroups.module.css";

const UserStudyGroups = ({ providerKey, entityField, studyGroupId, courseData, setCourseData, changeCurrentStep }) => {

    const { texts } = useSelector(state => state.translate);
    const { userDetails } = useSelector(state => state.auth);
    const filters = useMemo(() => studyGroupsBySchoolIdFilters(userDetails?.defaultSchool?.id), [userDetails?.defaultSchool?.id]);
    const studyGroups = useSelector(state => selectEntitiesByFilters(state, filters));
    const [groupsData, setGroupsData] = useState({ availableGroups: [], unavailableGroups: [] });

    useEffect(() => {
        if (studyGroupId) {
            const studyGroup = studyGroups?.find(g => g.id === studyGroupId);
            if (studyGroup) {
                setGroupsData({
                    availableGroups: ((entityField == null || !studyGroup[entityField]?.groupId) && !studyGroup.disable) ? [studyGroup] : [],
                    unavailableGroups: ((entityField != null && studyGroup[entityField]?.groupId) || studyGroup.disable) ? [studyGroup] : []
                });
            }
        }
        else if (studyGroups) {
            setGroupsData({
                availableGroups: studyGroups?.filter(g => (entityField == null || !g[entityField]?.groupId) && !g.disable),
                unavailableGroups: studyGroups?.filter(g => (entityField != null && g[entityField]?.groupId) || g.disable)
            });
        }
    }, [studyGroups, entityField, studyGroupId]);

    const chooseStudyGroup = (group) => {
        if ((entityField == null || !group[entityField]?.groupId) && !group.disable) {
            const course = {
                newName: null,
                name: group.name,
                schoolId: group.schoolId,
                description: `${group.schoolName} ${group.schoolId}`,
                studyGroupId: group.id,
                gcrGroupId: group.gcrGroupId
            };
            setCourseData(course);
        }
    };

    return (
        studyGroups?.length > 0 ?
            <div className={classes.Groups} >
                <StudyGroupListSection title={texts.studyGrupAvailable} groups={groupsData?.availableGroups} selectable selectedId={courseData?.studyGroupId} onSelect={chooseStudyGroup} />
                <StudyGroupListSection title={texts.studyGrupIsNotAvailable} groups={groupsData?.unavailableGroups} selectable={false} />
            </div >
            :
            <div className={classes.NoStudyGroup}>
                {texts.noStudyGroup}
            </div>
    );
};

export default UserStudyGroups;
